import type { LocaleType } from "lib/apollo/types"

export const APP_URLS = {
  memberBenefits: "/account/member-benefits",
  orderHistory: "/account/order-history",
  myAccount: "/account",
  shoppingCart: "/basket",
  searchAction: "/shop/search",
  myMembership: "/account/my-membership",
  wishlist: "/account/wishlist",
  profile: "/account/profile",
  addressBook: "/account/address-book",
  referAFriend: "/account/refer-a-friend",
  orderItAgain: "/account/favourites/order-it-again",
  forYou: "/account/favourites/for-you",
  favourites: "/account/favourites",
}

export const getCancellationLink = (locale: LocaleType): string => {
  return locale === "en-GB"
    ? "https://beautypiehelp.zendesk.com/hc/en-gb/articles/360021483459-HOW-DO-I-CANCEL-MY-MEMBERSHIP-"
    : "https://beautypiehelp-us.zendesk.com/hc/en-us/articles/360021483479-HOW-DO-I-CANCEL-MY-MEMBERSHIP-"
}

export const contactMemberHappinessLink = (locale: LocaleType): string => {
  return locale === "en-GB"
    ? "https://beautypiehelp.zendesk.com/hc/en-gb/requests/new"
    : "https://beautypiehelp-us.zendesk.com/hc/en-us/articles/360021400380-CONTACT-US"
}

export const getReturnsPolicyLink = (locale: LocaleType): string => {
  return locale === "en-GB"
    ? "https://beautypiehelp.zendesk.com/hc/en-gb/articles/360014621880-CAN-I-RETURN-A-BEAUTY-PIE-ITEM-IF-I-DON-T-LIKE-IT-"
    : "https://beautypiehelp.zendesk.com/hc/en-us/articles/360014621880-CAN-I-RETURN-A-BEAUTY-PIE-ITEM-IF-I-DON-T-LIKE-IT-"
}
